export const PerformanceAssessmentDocumentationMode = {
  COMPETENCE_ONLY: 'COMPETENCE_ONLY',
  SCHOOL_GRADE: 'SCHOOL_GRADE',
  VISUAL: 'VISUAL',
} as const;

export type PerformanceAssessmentDocumentationMode =
  (typeof PerformanceAssessmentDocumentationMode)[keyof typeof PerformanceAssessmentDocumentationMode];
